/**
 * RosterPanel — module for deployed robots roster UI logic.
 *
 * Currently a lightweight wrapper. The roster/saved-designs methods remain
 * in UIScene due to deep coupling with UIScene state (rosterContainer,
 * savedDesignsContainer, robotManager, selectedRobot, phase, resources, etc.).
 *
 * Methods that belong here conceptually (future extraction candidates):
 * - refreshRoster, refreshSavedDesigns, selectSavedDesign, editSavedDesign
 * - refreshSensorForSelection, setSensorCirclesVisible
 * - updateRosterScrollIndicator
 *
 * To extract: create a RosterPanelCallbacks interface similar to
 * RobotInspectorCallbacks, pass UIScene state via getters, and move
 * the method implementations here.
 */
export class RosterPanel {
  setup(): void {}
  destroy(): void {}
}
